export default {
  actions: 'Actions',
  name: 'Name',
  phone: 'Phone',
  email: 'Email',
  type: 'Type',
  created: 'Created at',
  status: 'Status',
  agentDescription: 'The agents have access to basic chat and person features, if you want to add or remove permissions according to your needs, you can do it choosing "customized"',
  coordinatorDescription: 'The coordinators have access to advanced chat and person features, including campaigns and forms, if you want to add or remove permissions according to your needs, you can do it choosing "customized"',
  adminDescription: 'The admins have full access, they are the only ones that can configure the app, if you want to add or remove permissions according to your needs, you can do it choosing "customized"'
}
